export type CommitteeType = 'IC1' | 'IC2';
export type CommitteeStatus = 'Scheduled' | 'Held' | 'Cancelled' | 'Postponed';
export type CommitteeDecision =
  | 'Approved'
  | 'Rejected'
  | 'ApprovedWithReservations'
  | 'DeepDiveRequested'
  | 'Postponed';

export interface CommitteeListItem {
  id: string;
  dealId: string;
  type: CommitteeType;
  scheduledDateUtc: string;
  heldDateUtc: string | null;
  status: CommitteeStatus;
  decision: CommitteeDecision | null;
  participantUserIds: string[];
}

export interface CommitteeResponse extends CommitteeListItem {
  minutesComment: string | null;
  eTag: string;
}

export const COMMITTEE_STATUS_LABELS: Record<CommitteeStatus, string> = {
  Scheduled: 'Agendado',
  Held: 'Realizado',
  Cancelled: 'Cancelado',
  Postponed: 'Adiado',
};

export const COMMITTEE_DECISION_LABELS: Record<CommitteeDecision, string> = {
  Approved: 'Aprovado',
  Rejected: 'Rejeitado',
  ApprovedWithReservations: 'Aprovado com ressalvas',
  DeepDiveRequested: 'Deep dive solicitado',
  Postponed: 'Adiado',
};
